module.exports = __webpack_public_path__ + "img/card-light.5a2048cf.svg";